
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n/index";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import objectPath from "object-path";
import Swal from "sweetalert2";

export default defineComponent({
  name: "kt-user-menu",
  components: {},
  setup() {
    const router = useRouter();
    const i18n = useI18n();
    const store = useStore();
    const user = computed(() => {
      return store.getters.getUser;
    });

    const op = computed(() => objectPath);

    i18n.locale.value = localStorage.getItem("lang")
      ? (localStorage.getItem("lang") as string)
      : "en";

    const countries = {
      en: {
        flag: "media/flags/united-states.svg",
        name: "English",
      },
      es: {
        flag: "media/flags/spain.svg",
        name: "Spanish",
      },
      de: {
        flag: "media/flags/germany.svg",
        name: "German",
      },
      ja: {
        flag: "media/flags/japan.svg",
        name: "Japanese",
      },
      fr: {
        flag: "media/flags/france.svg",
        name: "French",
      },
    };

    const signOut = async () => {
      try {
        const response = await store.dispatch(Actions.SIGNOUT);
        if (response !== true) throw new Error();
        window.localStorage.removeItem("access_token");
        router.push("/sign-in");
        setTimeout(() => {
          store.commit(Mutations.SET_DEFAULT_AUTH);
          store.commit(Mutations.SET_DEFAULT_BUSINESS_STORE);
          store.commit(Mutations.SET_DEFAULT_EXPERT_STORE);
          store.commit(Mutations.SET_DEFAULT_FOUNDER_STORE);
          store.commit(Mutations.SET_DEFAULT_INVESTOR_STORE);
          store.commit(Mutations.SET_DEFAULT_PAYMENT_STORE);
          store.commit(Mutations.SET_DEFAULT_PLANS_STORE);
          store.commit(Mutations.SET_DEFAULT_ROLE_STORE);
        }, 100);
      } catch (err) {
        window.localStorage.removeItem("access_token");
        router.push("/sign-in");
        const [error] = Object.keys(store.getters.getErrors);
        Swal.fire({
          text: store.getters.getErrors[error],
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
    };

    const setLang = (lang) => {
      localStorage.setItem("lang", lang);
      i18n.locale.value = lang;
    };

    const currentLanguage = (lang) => {
      return i18n.locale.value === lang;
    };

    const currentLangugeLocale = computed(() => {
      return countries[i18n.locale.value];
    });

    return {
      signOut,
      setLang,
      currentLanguage,
      currentLangugeLocale,
      countries,
      user,
      op,
    };
  },
});
